import SiteNav from "./components/SiteNav";
import Hero from "./components/Hero";
import FeaturedGrid from "./components/FeaturedGrid";
import TopicWall from "./components/TopicWall";
import DossierIndex from "./components/DossierIndex";
import CommentWall from "./components/CommentWall";
import EditorNotes from "./components/EditorNotes";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <SiteNav />
      <main>
        <Hero />
        <FeaturedGrid />
        <TopicWall />
        <DossierIndex />
        <CommentWall />
        <EditorNotes />
      </main>
      <SiteFooter />
    </div>
  );
}